import React from 'react'

export default class IconsDnDTextArea extends React.Component {
    render() {
        let color = '#000000'
        // if (this.props.color) color = this.props.color
        let className = 'icons-icon'
        return (
            <svg
                className={className}
                style={this.props.style}
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
            >
                <path
                    d='M12.6667 3.19995H3.33333C2.59695 3.19995 2 3.81396 2 4.57138V11.4285C2 12.1859 2.59695 12.8 3.33333 12.8H12.6667C13.403 12.8 14 12.1859 14 11.4285V4.57138C14 3.81396 13.403 3.19995 12.6667 3.19995Z'
                    stroke={color}
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M4.40005 9.5999H7.60005M10.0001 9.5999H11.6001M4.40005 6.3999H6.00005M8.40005 6.3999H11.6001'
                    stroke={color}
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </svg>
        )
    }
}
